const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

export default (a: string | null | undefined, b: string | null | undefined) => collator.compare(a || 'a', b || 'b');
